import React, { useState, useEffect } from 'react';
import './ImageCarousel.css';

interface ImageCarouselProps {
  images: string[];
  fullHeight?: boolean;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images, fullHeight }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds
    return () => clearInterval(interval);
  }, [images.length]);

  if (!images || images.length === 0) {
    return <div>No images to display.</div>;
  }

  return (
    <div className={`carousel ${fullHeight ? 'full-height' : ''}`}>
      <div
        className="carousel-inner"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((image, index) => (
          <img src={image} alt={`Slide ${index}`} key={index} className="carousel-item" />
        ))}
      </div>
      <button onClick={() => setCurrentIndex((currentIndex - 1 + images.length) % images.length)} className="carousel-control prev">&#10094;</button>
      <button onClick={() => setCurrentIndex((currentIndex + 1) % images.length)} className="carousel-control next">&#10095;</button>
    </div>
  );
};

export default ImageCarousel; 